<template>
    <div class="py-6 px-1 text-left" id="createSubscription">
        <address-form
            v-model="deliveryAddress"
            @postcodeChanged="getCourierName">
        </address-form>

        <instructions
            v-model="deliveryComment"
            :require="true">
        </instructions>

        <property-type
            :require="true"
            v-model="propertyType">
        </property-type>

        <div class="w-full p-2" v-if="errorHandler.getAllErrors()">
            <ul class="error list-disc text-center">
                <li v-for="(errorMsg, key) in errorHandler.getAllErrors()" :key="key">
                    <span class="font-bold capitalize" v-text="key"></span>:
                    <span class="font-normal" v-text="errorMsg"></span>
                </li>
            </ul>
        </div>

        <div class="w-full md:flex pt-4 pb-2 px-2">
            <div class="w-full md:w-1/2 px-0 md:px-1 py-1 md:py-0">
                <button
                    class="w-1/2 btn btn--secondary-black btn--auto-width btn--full-width"
                    @click="close">
                    Cancel
                </button>
            </div>
            <div class="w-full md:w-1/2 px-0 md:px-1 py-1 md:py-0">
                <submit-button
                    class="btn--full-width"
                    @click="submit"
                    :hoverable="false"
                    color="green"
                    :processing="formProcessing">
                    Create
                </submit-button>
            </div>
        </div>
    </div>
</template>

<script>
import required from 'vuelidate/src/validators/required';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';
import DeliveryInstructionsField from '@/components/forms/fields/DeliveryInstructionsField';
import DeliveryAddressForm from '@/components/forms/addresses/DeliveryAddressForm';
import DeliveryAddressPropertyTypeField from '@/components/forms/fields/LegacyDeliveryAddressPropertyTypeField';
import PostcodeService from '@/services/logistics/PostcodeService';

export default {
    name: 'CreateSubscriptionForm',
    data() {
        return {
            address: {
                addressLine1: null,
                addressLine2: null,
                city: null,
                postcode: null,
            },
            courierName: null,
            deliveryComment: null,
            propertyType: null,
            errorHandler: new ErrorResponseHandler(),
            formProcessing: false,
        };
    },
    methods: {
        close() {
            this.$emit('closed');
        },
        getCourierName() {
            PostcodeService.GetFirstDeliveryDayForPostcode(this.address.postcode)
                .then(response => this.courierName = response.data.properties.courier_name);
        },
        handleCreatingSubscriptionViaApi() {
            let newAddress = {
                firstName: this.authUser.first_name,
                lastName: this.authUser.last_name,
                address1: this.address.addressLine1,
                address2: this.address.addressLine2,
                city: this.address.city,
                country: process.env.VUE_APP_COUNTRY_ISO,
                postcode: this.address.postcode,
                deliveryComment: this.deliveryComment,
                propertyType: this.propertyType,
                plan_slug: this.planInterval,
            };

            let service = new SubscriptionService();
            service.createSubscription(newAddress)
                .then(() => {
                    setTimeout(() => {
                        this.$store.dispatch('subscription/fetchAllSubscriptions', true);
                        this.$store.dispatch('address/fetchAllAddresses', true);
                    }, 1000);

                    this.$scrollTo('.main');
                    this.toggleFormProcessing();
                    this.close();
                })
                .catch(error => {
                    this.errorHandler.setResponse(error.response.data);
                    this.toggleFormProcessing();
                });
        },
        submit() {
            this.toggleFormProcessing();
            this.validateInput();
        },
        validateInput() {
            this.$v.$touch();
            this.areAllFormFieldsValid ? this.handleCreatingSubscriptionViaApi() : this.forceRequiredValidationMessagesVisibility();
        },
        forceRequiredValidationMessagesVisibility() {
            if (this.address.addressLine1 === null) this.address.addressLine1 = '';
            if (this.address.city === null) this.address.city = '';
            if (this.address.postcode === null) this.address.postcode = '';
            if (this.deliveryComment === null) this.deliveryComment = '';
            if (this.propertyType === null) this.propertyType = '';

            this.$scrollTo(`#createSubscription`);
            this.toggleFormProcessing();
        },
        toggleFormProcessing() {
            this.formProcessing = !this.formProcessing;
        },
    },
    computed: {
        deliveryAddress: {
            get() {
                return this.address;
            },
            set(updatedAddress) {
                this.address.addressLine1 = updatedAddress.addressLine1;
                this.address.addressLine2 = updatedAddress.addressLine2;
                this.address.city = updatedAddress.city;
                this.address.postcode = updatedAddress.postcode;
            },
        },
        authUser() {
            return this.$store.getters['account/getUser'];
        },
        areAllFormFieldsValid() {
            return !this.$v.$invalid;
        },
        showW3W() {
            return this.courierName === 'Global' || this.courierName === 'FF Vans' || this.courierName === 'FF Bikes';
        },
        planInterval() {
            return this.$store.getters['register/getSelectedPlan']?.plan_interval;
        },
    },
    validations: {
        address: {
            addressLine1: {
                required,
            },
            city: {
                required,
            },
            postcode: {
                required,
            },
        },
        propertyType: {
            required,
        },
        deliveryComment: {
            required,
        },
    },
    components: {
        AddressForm: DeliveryAddressForm,
        Instructions: DeliveryInstructionsField,
        PropertyType: DeliveryAddressPropertyTypeField,
        SubmitButton,
    },
};
</script>
